import { Navigate, RouteObject } from 'react-router-dom';
import React, { lazy, Suspense } from 'react';
import { RoutePaths } from '@utils/route.utils.ts';

const InfoCenter = lazy(() => import('./info-center.tsx'));
const InformationsComponent = lazy(
  () => import('./pages/informations/informations.tsx')
);
const CategoriesComponent = lazy(
  () => import('./pages/categories/categories.tsx')
);

export const infoCenterRoutes: RouteObject[] = [
  {
    path: '',
    element: (
      <Suspense>
        <InfoCenter />
      </Suspense>
    ),
    children: [
      {
        index: true,
        element: (
          <Navigate
            to={RoutePaths.Core.InfoCenter.Categories.absolutePath}
            replace
          />
        )
      },
      {
        path: RoutePaths.Core.InfoCenter.Informations.path,
        element: (
          <Suspense>
            <InformationsComponent />
          </Suspense>
        )
      },
      {
        path: RoutePaths.Core.InfoCenter.Categories.path,
        element: (
          <Suspense>
            <CategoriesComponent />
          </Suspense>
        )
      }
    ]
  }
];
